/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { getCommandIntelligenceTokens } from '../../../theme/commandIntelligenceTokens';

/**
 * @param {import('@mui/material').Theme & { validateMode?: Function }} theme
 */
export const getFeedbackDialogStyles = theme => {
  const tokens = getCommandIntelligenceTokens(theme);

  return {
    questionBlock: {
      mb: 2.5,
    },
    questionLabel: {
      display: 'block',
      mb: 1,
      fontFamily: tokens.fontStack,
      color: tokens.textPrimary,
      fontWeight: 500,
    },
    chipRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 0.75,
    },
    choiceChip: {
      borderRadius: tokens.radiusChip,
      borderColor: tokens.borderSubtle,
      fontFamily: tokens.fontStack,
      '& .MuiChip-label': {
        px: 1.25,
      },
    },
    choiceChipSelected: {
      borderColor: tokens.accentPrimary,
    },
  };
};
